import template from './errorsLegend.html';
import controller from './errorsLegend.controller';

let errorsLegendComponent = {
  restrict: 'E',
  bindings: {},
  transclude:true,
  template,
  controller,
  controllerAs: 'vm'
};

export default errorsLegendComponent;



// WEBPACK FOOTER //
// ./app/common/errorsLegend/errorsLegend.component.js